


































































































import Vue from 'vue'
import { ProductCategory } from '@/model/productCategory'
import BaseImage from '@/common/components/BaseImage.vue'
import { SVG_PLACEHOLDER_IMAGES } from '@/common/constants'

export default Vue.extend({
  name: 'SearchModal',
  components: {
    BaseImage
  },
  props: {
    productCategories: {
      type: Array as () => ProductCategory[],
      required: true
    },
    selectedCategories: {
      type: Array as () => Array<number>,
      required: true,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: []
    }
  },
  computed: {
    isAllClicked(): boolean {
      return this.selectedCategories.length == this.productCategories.length
    },
    placeholder(): string {
      return SVG_PLACEHOLDER_IMAGES.SQUARE
    }
  },
  methods: {
    close(){
      this.$emit('close')
    },
    onSelectFilterCategories(event: Event) {
      this.$emit('updateFilter', Number((event.target as HTMLInputElement).value))
    },
    onClickCategories(index?: number) {
      if (index) {
        this.$emit('onClickCategory', index)
      } else {
         if (this.isAllClicked) {
          this.$emit('updateCategories',[])
        } else {
          const tempArray = this.productCategories.map(category => category.id)
          this.$emit('updateCategories', tempArray)
        }
      }
    },
    isItemSelected(index: number): boolean {
      return (this.selectedCategories.includes(index))
    },
    savingCategoriesState() {
      this.$emit('savingCategoriesState', {
        categories: this.selectedCategories
      })
    }
  }
})
